import React from "react";
import {DetailHeroSummaryProvider, useRegisterDetailHeroSummary} from "./DetailHeroSummaryContext";
import {DetailFormHeroHeader} from "./DetailFormHeroHeader";
import {DetailSummaryBar} from "./DetailSummaryBar";
import "./detailListLayout.css";

function DetailFormPageChrome({title, meta, actions, children}) {
    const {hideInlineSummaryBar} = useRegisterDetailHeroSummary({title, meta, actions, trackActions: true});

    return (
        <>
            <DetailFormHeroHeader />
            {!hideInlineSummaryBar ? (
                <DetailSummaryBar title={title} meta={meta} actions={actions} />
            ) : null}
            {children}
        </>
    );
}

/** 수정·접수·등록 — hero 요약 + 본문 */
export function DetailFormPageShell({
    title,
    meta,
    actions,
    className = "common-container container-height detail-list-layout asset-detail-list-layout border-l-gray",
    children,
}) {
    return (
        <div className={className}>
            <DetailHeroSummaryProvider>
                <DetailFormPageChrome title={title} meta={meta} actions={actions}>
                    {children}
                </DetailFormPageChrome>
            </DetailHeroSummaryProvider>
        </div>
    );
}

/** ContentDetailInfoShell 등 — hero 요약 + 탭 본문 */
export function DetailFormTabChrome({children}) {
    return (
        <DetailHeroSummaryProvider>
            <DetailFormHeroHeader />
            {children}
        </DetailHeroSummaryProvider>
    );
}
